import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, DrawerContent, useDrawerContext, useModalContext, } from '@chakra-ui/react';
import { DRAG_DRAWER_CONTENT_CLASS_NAME } from '@cronos-app/chakra';
import { useDragController } from '@cronos-app/utils';
import { useCallback, useId } from 'react';
import { DragBar } from './DragBar';
export const DragDrawerContent = ({ children, hideTopBorder, dragDisabled, ...props }) => {
    const id = useId();
    const { onClose } = useModalContext();
    const { placement } = useDrawerContext();
    const { ref, isTouching, triggerRef } = useDragController({
        onDrag: useCallback((ele, offsetY) => (ele.style.bottom = `-${Math.max(offsetY, 0)}px`), []),
        onClose,
        onReset: useCallback((ele) => (ele.style.bottom = '0'), []),
        disabled: dragDisabled,
    });
    if (placement !== 'bottom')
        return _jsx(DrawerContent, { ...props, children: children });
    return (_jsxs(DrawerContent, { position: "relative", ...props, className: `${props.className ?? ''} ${DRAG_DRAWER_CONTENT_CLASS_NAME} ${id}`, ref: ref, children: [!hideTopBorder && (_jsx(Box, { bg: "linear-gradient(270deg, rgba(255, 255, 255, 0) 6.99%, #12CFF4 53.49%, #34F792 100%)", h: "4px" })), _jsx(DragBar, { ref: triggerRef, hidden: dragDisabled, position: "absolute", top: "0", left: "50%", transform: "translateX(-50%)", pt: "12px", buttonContainerProps: {
                    alignItems: 'flex-start',
                }, isTouching: isTouching, onToggle: onClose }), children] }));
};
